import React, { useState, useEffect } from "react";
import {
  Database,
  UploadCloud,
  FileSpreadsheet,
  Search,
  CheckCircle2,
  XCircle,
  MoreVertical,
  X,
  Plus,
  Edit,
  Eye,
  Trash2,
} from "lucide-react";
import * as XLSX from "xlsx";

const DatabaseManagement = () => {
  const [actionMenu, setActionMenu] = useState(null); // mac of open row
  const [viewSite, setViewSite] = useState(null); // site object for modal
  const deleteSiteDatabase = async (siteMac) => {
    if (!window.confirm("❌ למחוק את המאגר של האתר?")) return;

    try {
      const res = await fetch(
        `https://db2sg.com/tagweigh/api/database?siteMac=${siteMac}&action=delete`,
        { method: "POST" }
      );

      if (!res.ok) throw new Error("Delete failed");
      alert("✅ המאגר נמחק בהצלחה");
      window.location.reload();
    } catch (e) {
      console.error(e);
      alert(e);
    } finally {
    }
  };
  const [editSite, setEditSite] = useState(null);
  const [editSettings, setEditSettings] = useState({
    name: "",
    weight_low: "",
    weight_high: "",
    reader_type: "",
    read_attempts: "",
    weight_retry: "",
    broadcast_mode: "",
    cellular: false,
    notification: false,
  });
  const [firmwareMap, setFirmwareMap] = useState({});
  useEffect(() => {
    const fetchFirmware = async () => {
      try {
        const res = await fetch(
          "https://db2sg.com/tagweigh/api/device_firmware?action=list"
        );

        const data = await res.json();

        if (!data?.devices) return;

        // Convert array → map by MAC
        const map = {};
        data.devices.forEach((d) => {
          map[d.mac.toLowerCase()] = d;
        });

        setFirmwareMap(map);
      } catch (err) {
        console.error("Failed to load firmware list", err);
      }
    };

    fetchFirmware();
  }, []);

  const openEditModal = async (site) => {
    try {
      const token = localStorage.getItem("userToken");

      // Fetch full site config from API
      const res = await fetch(
        `https://db2sg.com/tagweigh/api/sites?mac=${site.mac}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (!res.ok) throw new Error("Failed to load settings");

      const data = await res.json();
      const fullSite = data[0] || data;

      // Open modal
      setEditSite(fullSite);

      // Fill form with latest values
      setEditSettings({
        name: fullSite.name || "",
        weight_low: fullSite.weight_low || "400",
        weight_high: fullSite.weight_high || "800",
        reader_type: fullSite.reader_type || "ASR550",
        read_attempts: fullSite.read_attempts || "3",
        weight_retry: fullSite.weight_retry || "3",
        broadcast_mode: fullSite.broadcast_mode || "Batch",
        cellular: fullSite.cellular === "1",
        notification: fullSite.notification === "1",
      });
      const firmware = firmwareMap[site.mac.toLowerCase()];
      console.log("Firmware for site:", firmware);
    } catch (err) {
      console.error(err);
      alert("❌ Could not load current settings");
    }
  };

  useEffect(() => {
    const handleClickOutside = () => {
      setActionMenu(null);
    };

    // Listen for any click on page
    window.addEventListener("click", handleClickOutside);

    return () => {
      window.removeEventListener("click", handleClickOutside);
    };
  }, []);

  const deleteSite = async (siteMac) => {
    if (!window.confirm("❌ למחוק את של האתר?")) return;

    try {
      const res = await fetch(
        `https://db2sg.com/tagweigh/api/database?siteMac=${siteMac}&action=deletesite`,
        { method: "POST" }
      );

      if (!res.ok) throw new Error("Delete failed");
      alert("✅ נמחק בהצלחה");
      window.location.reload();
    } catch (e) {
      console.error(e);
      alert(e);
    } finally {
    }
  };
  const [stats, setStats] = useState({
    totalCalves: 0,
    sitesWithCalves: 0,
    sitesWithoutCalves: 0,
  });
  const userRole = localStorage.getItem("role");
  const userId = localStorage.getItem("id");
  const [sites, setSites] = useState([]);
  const [siteOptions, setSiteOptions] = useState([]);
  const [selectedSiteMac, setSelectedSiteMac] = useState("");
  const [selectedFile, setSelectedFile] = useState(null);

  const [uploading, setUploading] = useState(false);
  const [cardFilter, setCardFilter] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const token = localStorage.getItem("userToken");

        // 1. Fetch Calves Stats
        const calvesRes = await fetch(
          `https://db2sg.com/tagweigh/api/calves?_t=${Date.now()}`
        );
        const calvesData = await calvesRes.json();

        // 2. Fetch Sites for Dropdown/Table
        const sitesRes = await fetch(
          `https://db2sg.com/tagweigh/api/sites?_t=${Date.now()}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        const sitesData = await sitesRes.json();

        // --- FILTERING LOGIC ---
        let filteredTableData = calvesData.sites || [];
        let filteredOptions = sitesData || [];

        if (userRole === "user") {
          // Filter table records by user ID
          filteredTableData = filteredTableData.filter(
            (s) => s.user?.toString() === userId?.toString()
          );
          // Filter dropdown options by user ID
          filteredOptions = filteredOptions.filter(
            (s) => s.user?.toString() === userId?.toString()
          );

          // Auto-select the only available site for the user
          if (filteredOptions.length > 0) {
            setSelectedSiteMac(filteredOptions[0].mac);
          }
        }

        setSites(filteredTableData);
        setSiteOptions(
          filteredOptions.map((s) => ({
            label: `${s.name} (${s.mac})`,
            value: s.mac,
          }))
        );

        setStats({
          totalCalves: calvesData.totalCalves,
          sitesWithCalves: calvesData.sitesWithCalves,
          sitesWithoutCalves: calvesData.sitesWithoutCalves,
        });
      } catch (err) {
        console.error("Failed to load data", err);
      }
    };

    fetchData();
  }, [userRole, userId]);

  const getValueByKeyContains = (row, text) => {
    if (!row || !text) return "";

    const clean = (str) =>
      String(str)
        .replace(/["'`]/g, "") // remove quotes/backticks
        .replace(/\s+/g, "") // remove spaces
        .toLowerCase();

    const searchText = clean(text);

    const key = Object.keys(row).find((k) => clean(k).includes(searchText));
    console.log(key, row, text);
    return key ? row[key] : "";
  };
  const uploadBatchToServer = async (calves, merge) => {
    try {
      console.log(calves, merge, calves.length, selectedSiteMac);
      setUploading(true);

      if (!merge) {
        await fetch(
          `https://db2sg.com/tagweigh/api/database?siteMac=${selectedSiteMac}&action=delete`,
          {
            method: "POST",
          }
        );
      }

      const res = await fetch(
        "https://db2sg.com/tagweigh/api/database?action=batch",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            siteMac: selectedSiteMac,
            calves: calves.map((c) => ({
              chipId: c.chip_id,
              earNumber: c.ear_number,
              burnNumber: c.burn_number,
              barcode: c.barcode,
            })),
          }),
        }
      );

      if (!res.ok) throw new Error("Upload failed");
      console.log(await res.json());
      alert(`Data ${merge ? "merged" : "synchronized"} successfully`);
      window.location.reload(); // refresh cards + table
    } catch (e) {
      console.log(e);
      alert(e.message);
    } finally {
      setUploading(false);
    }
  };
  const handleFileUpload = async (file) => {
    if (!selectedSiteMac) {
      alert("Please select a site first");
      return;
    }

    const reader = new FileReader();

    reader.onload = (e) => {
      let workbook;

      if (file.name.endsWith(".csv")) {
        // 🔥 READ CSV AS UTF-8 TEXT
        workbook = XLSX.read(e.target.result, {
          type: "string",
          raw: false,
        });
      } else {
        // Excel files
        workbook = XLSX.read(e.target.result, { type: "binary" });
      }

      // const workbook = XLSX.read(e.target.result, { type: "binary" });
      const sheet = workbook.Sheets[workbook.SheetNames[0]];
      const data = XLSX.utils.sheet_to_json(sheet);

      const calves = data
        .map((row) => ({
          chip_id: String(
            row.chip_id ||
              row["מספר שבב"] ||
              getValueByKeyContains(row, "מספר") ||
              getValueByKeyContains(row, "Chip") ||
              ""
          ).trim(),
          ear_number: String(
            row.ear_number ||
              row["מספר אוזן"] ||
              getValueByKeyContains(row, "ברקוד") ||
              getValueByKeyContains(row, "Ear") ||
              ""
          ).trim(),
          burn_number: String(
            row.burn_number ||
              row["מספר צריבה"] ||
              "" ||
              getValueByKeyContains(row, "Burn")
          ).trim(),
          barcode: String(
            row.barcode ||
              row["ברקוד"] ||
              "" ||
              getValueByKeyContains(row, "Barcode")
          ).trim(),
        }))
        .filter((c) => c.chip_id || c.ear_number);

      if (!calves.length) {
        alert("No calves found");
        return;
      }
      const currentSite = sites.find((s) => s.mac === selectedSiteMac);
      let merge = false;

      if (currentSite && currentSite.calvesCount > 0) {
        merge = window.confirm("OK = Merge\nCancel = Overwrite");
      } else {
        merge = false;
      }

      uploadBatchToServer(calves, merge);
    };
    if (file.name.endsWith(".csv")) {
      reader.readAsText(file, "UTF-8"); // 🔥 VERY IMPORTANT
    } else {
      reader.readAsBinaryString(file);
    }
  };
  const [isUploadModalOpen, setIsUploadModalOpen] = useState(false);

  const [searchTerm, setSearchTerm] = useState("");
  const [showSearch, setShowSearch] = useState(false);

  const filteredSites = sites
    .filter(
      (site) =>
        site.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
        site.mac.toLowerCase().includes(searchTerm.toLowerCase())
    )
    .filter((site) => {
      if (!cardFilter) return true;
      if (cardFilter === "active") return site.calvesCount > 0;
      if (cardFilter === "empty") return site.calvesCount === 0;
      return true;
    });

  const saveSiteSettings = async () => {
    try {
      const token = localStorage.getItem("userToken");

      const res = await fetch("https://db2sg.com/tagweigh/api/sites?config=1", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          mac: editSite.mac,
          ...editSettings,
        }),
      });

      if (!res.ok) throw new Error("Update failed");

      alert("✅ Settings updated successfully!");
      setEditSite(null);
      window.location.reload();
    } catch (err) {
      console.error(err);
      alert("❌ Failed to update settings");
    }
  };

  return (
    <div className="animate-in fade-in slide-in-from-bottom-8 duration-1000 pb-20 ltr">
      <div className="flex justify-between items-center mb-10">
        <button
          onClick={() => setIsUploadModalOpen(true)}
          className="flex items-center gap-2 px-6 py-4 bg-slate-900 text-white font-black rounded-2xl hover:bg-black transition-all shadow-lg shadow-slate-200 active:scale-95"
        >
          <Plus size={20} />
          <span>העלה קובץ אצווה</span>
        </button>
      </div>
      {/* 1. Statistics Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mb-10">
        {userRole !== "user" && (
          <>
            <StatCard
              label='סה"כ עגלים במאגר'
              value={stats.totalCalves}
              icon={<Database size={18} />}
              color="text-blue-500"
              bg="bg-blue-50"
              active={cardFilter === null}
              onClick={() => setCardFilter(null)}
            />

            <StatCard
              label="אתרים עם מאגר פעיל"
              value={stats.sitesWithCalves}
              icon={<CheckCircle2 size={18} />}
              color="text-emerald-500"
              bg="bg-emerald-50"
              active={cardFilter === "active"}
              onClick={() =>
                setCardFilter(cardFilter === "active" ? null : "active")
              }
            />

            <StatCard
              label="אתרים ללא מאגר"
              value={stats.sitesWithoutCalves}
              icon={<XCircle size={18} />}
              color="text-red-500"
              bg="bg-red-50"
              active={cardFilter === "empty"}
              onClick={() =>
                setCardFilter(cardFilter === "empty" ? null : "empty")
              }
            />
          </>
        )}
      </div>

      {/* 2. Upload Section */}
      {isUploadModalOpen && (
        <div className="fixed inset-0 bg-slate-900/60 backdrop-blur-sm z-[100] flex items-center justify-center p-4">
          <div className="bg-white rounded-[3rem] shadow-2xl w-full max-w-3xl overflow-hidden animate-in zoom-in duration-300">
            <div className="px-10 py-6 border-b border-slate-50 flex items-center justify-between bg-slate-50/50">
              <div className="flex items-center gap-4">
                <div className="p-2 bg-blue-500 text-white rounded-xl">
                  <UploadCloud size={20} />
                </div>
                <h3 className="text-xl font-black text-slate-900">
                  ייבוא נתונים מקובץ
                </h3>
              </div>
              <button
                onClick={() => setIsUploadModalOpen(false)}
                className="p-2 hover:bg-slate-200 rounded-full transition-colors"
              >
                <X size={24} />
              </button>
            </div>

            <div className="p-10">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
                <div className="space-y-2">
                  <label className="text-xs font-black text-slate-400 uppercase mr-2">
                    בחר אתר יעד
                  </label>
                  <select
                    value={selectedSiteMac}
                    onChange={(e) => setSelectedSiteMac(e.target.value)}
                    className="w-full bg-slate-50 border-2 border-slate-100 rounded-2xl p-4 font-bold text-slate-700 outline-none focus:border-blue-400 transition-all"
                  >
                    <option value="">-- בחר אתר --</option>
                    {siteOptions.map((s) => (
                      <option key={s.value} value={s.value}>
                        {s.label}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="space-y-2">
                  <label className="text-xs font-black text-slate-400 uppercase mr-2">
                    קובץ מקור
                  </label>
                  <div
                    onClick={() =>
                      document.getElementById("modalFileInput")?.click()
                    }
                    className="w-full bg-slate-50 border-2 border-dashed border-slate-200 rounded-2xl p-4 flex items-center gap-3 cursor-pointer hover:border-blue-400 transition-all"
                  >
                    <FileSpreadsheet
                      className={
                        selectedFile ? "text-emerald-500" : "text-slate-400"
                      }
                    />
                    <span className="text-sm font-bold truncate">
                      {selectedFile ? selectedFile.name : "לחץ לבחירת קובץ..."}
                    </span>
                  </div>
                  <input
                    id="modalFileInput"
                    type="file"
                    accept=".xlsx,.xls,.csv"
                    className="hidden"
                    onChange={(e) => setSelectedFile(e.target.files?.[0])}
                  />
                </div>
              </div>

              {/* Drag & Drop Zone */}
              <div
                onDragOver={(e) => e.preventDefault()}
                onDrop={(e) => {
                  e.preventDefault();
                  setSelectedFile(e.dataTransfer.files?.[0]);
                }}
                className="w-full border-2 border-dashed border-slate-100 rounded-[2rem] py-12 flex flex-col items-center justify-center bg-slate-50/50 mb-8"
              >
                <UploadCloud size={40} className="text-slate-300 mb-2" />
                <p className="font-bold text-slate-500">גרור קובץ לכאן</p>
              </div>

              <div className="flex gap-4">
                <button
                  onClick={() => handleFileUpload(selectedFile)}
                  disabled={uploading || !selectedFile || !selectedSiteMac}
                  className="flex-1 py-4 bg-slate-900 text-white font-black rounded-2xl hover:bg-blue-600 disabled:hover:bg-slate-900 transition-all disabled:opacity-30 disabled:cursor-not-allowed"
                >
                  {uploading ? "⏳ מעלה נתונים..." : "📤 בצע סנכרון עכשיו"}
                </button>
                <button
                  onClick={() => setIsUploadModalOpen(false)}
                  className="px-8 uppercase py-4 bg-slate-100 text-slate-600 font-bold rounded-2xl hover:bg-slate-200  transition-all"
                >
                  לְבַטֵל
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* 3. Tables Section */}
      <div className="bg-white rounded-[3rem] border border-slate-100 shadow-xl overflow-hidden mb-10">
        <div className="px-10 py-8 flex justify-between items-center border-b border-slate-50">
          <h3 className="text-2xl font-black text-slate-900 italic tracking-tight">
            📋 ניהול האתר
          </h3>

          <div className="flex items-center gap-3">
            {/* Animated Search Input */}
            <div
              className={`flex items-center bg-slate-50 rounded-xl px-3 transition-all duration-300 ${
                showSearch
                  ? "w-64 opacity-100"
                  : "w-0 opacity-0 overflow-hidden"
              }`}
            >
              <Search size={16} className="text-slate-400" />
              <input
                type="text"
                placeholder="חיפוש שם אתר או MAC..."
                className="bg-transparent border-none outline-none p-2 text-sm font-bold text-slate-700 w-full"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>

            <button
              onClick={() => setShowSearch(!showSearch)}
              className={`p-3 rounded-xl transition-all ${
                showSearch
                  ? "bg-slate-900 text-white shadow-lg"
                  : "bg-slate-50 text-slate-400 hover:bg-slate-100"
              }`}
            >
              {showSearch ? <X size={18} /> : <Search size={18} />}
            </button>
          </div>
        </div>
        <div className="overflow-x-auto">
          <table className="w-full text-center">
            <thead>
              <tr className="bg-slate-50 text-[10px] font-black text-grey-400 uppercase tracking-[2px]">
                <th className="px-4 py-5">אתר</th>
                <th className="px-4 py-5">כמות עגלים</th>
                <th className="px-4 py-5">סטטוס</th>
                <th className="px-4 py-5 ">פעולות</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-50">
              {filteredSites.length > 0 ? (
                filteredSites.map((site) => (
                  <TableRow
                    key={site.mac}
                    name={site.name}
                    count={site.calvesCount}
                    update="--"
                    valid={site.calvesCount}
                    site={site}
                    actionMenu={actionMenu}
                    setActionMenu={setActionMenu}
                    onView={(s) => setViewSite(s)}
                    onDelete={deleteSiteDatabase}
                    onDeleteSite={deleteSite}
                    userRole={userRole}
                    status={site.status === "active" ? "Active" : "No Database"}
                    onEdit={(s) => openEditModal(s)}
                  />
                ))
              ) : (
                <tr>
                  <td colSpan="6" className="py-20 text-center">
                    <div className="flex flex-col items-center opacity-30">
                      <Search size={48} className="mb-2" />
                      <p className="font-black">לא נמצאו אתרים תואמים</p>
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      {viewSite && (
        <div className="fixed inset-0 bg-black/40 z-50 flex items-center justify-center">
          <div className="bg-white rounded-[3rem] shadow-2xl w-full max-w-lg p-10 animate-in fade-in zoom-in">
            <h3 className="text-2xl font-black text-slate-900 mb-6">
              📍 פרטי אתר
            </h3>

            <div className="space-y-4 text-right">
              <div>
                <p className="text-xs font-black text-slate-400">שם אתר</p>
                <p className="font-bold">{viewSite.name}</p>
              </div>

              <div>
                <p className="text-xs font-black text-slate-400">MAC</p>
                <p className="font-mono">{viewSite.mac}</p>
              </div>

              <div>
                <p className="text-xs font-black text-slate-400">כמות עגלים</p>
                <p className="font-bold text-emerald-600">
                  {viewSite.calvesCount}
                </p>
              </div>
            </div>

            <div className="mt-8 flex justify-end gap-3">
              <button
                onClick={() => setViewSite(null)}
                className="px-6 py-3 rounded-xl bg-slate-100 font-bold hover:bg-slate-200"
              >
                סגור
              </button>
            </div>
          </div>
        </div>
      )}
      {editSite && (
        <div className="fixed inset-0 bg-slate-900/60 backdrop-blur-md z-50 flex items-center justify-center p-4">
          <div className="bg-white rounded-[2.5rem] shadow-[0_35px_60px_-15px_rgba(0,0,0,0.3)] w-full max-w-xl overflow-hidden animate-in fade-in zoom-in duration-300">
            {/* Header Section */}
            <div className="p-10 pb-2 pt-3 border-b border-slate-50">
              <div className="flex items-center gap-4 mb-0">
                <div className="w-12 h-12 bg-blue-50 rounded-2xl flex items-center justify-center text-blue-600">
                  <Edit size={20} className="rotate-0" />
                </div>
                <div>
                  <h5 className="text-2xl font-semibold tracking-tight text-slate-800">
                    עריכת הגדרות אתר
                  </h5>
                </div>
              </div>
            </div>

            {/* Modal Body - Scrollable if content exceeds screen */}
            <div className="p-10 pt-4 pb-4 max-h-[70vh] overflow-y-auto space-y-5 custom-scrollbar">
              {/* Section: Weight Thresholds */}
              <section>
                <h4 className="text-[10px] font-black text-blue-600 uppercase tracking-[0.2em] mb-4">
                  Site Name
                </h4>
                <div className="grid grid-cols-1 gap-4">
                  <div className="group">
                    <input
                      value={editSettings.name}
                      onChange={(e) =>
                        setEditSettings({
                          ...editSettings,
                          name: e.target.value,
                        })
                      }
                      className="w-full p-4 pt-2 pb-2 rounded-xl border-2 border-slate-100 bg-slate-50 font-bold text-slate-700 outline-none focus:border-blue-500 focus:bg-white transition-all shadow-sm"
                    />
                  </div>
                </div>
              </section>
              <section>
                <h4 className="text-[10px] font-black text-blue-600 uppercase tracking-[0.2em] mb-4">
                  Weight Thresholds
                </h4>
                <div className="grid grid-cols-2 gap-4">
                  <div className="group">
                    <label className="block text-[10px] font-black text-slate-400 uppercase mb-2 group-focus-within:text-blue-500 transition-colors">
                      Low
                    </label>
                    <input
                      value={editSettings.weight_low}
                      onChange={(e) =>
                        setEditSettings({
                          ...editSettings,
                          weight_low: e.target.value,
                        })
                      }
                      className="w-full p-4 pt-2 pb-2 rounded-xl border-2 border-slate-100 bg-slate-50 font-bold text-slate-700 outline-none focus:border-blue-500 focus:bg-white transition-all shadow-sm"
                    />
                  </div>
                  <div className="group">
                    <label className="block text-[10px] font-black text-slate-400 uppercase mb-2 group-focus-within:text-blue-500 transition-colors">
                      High
                    </label>
                    <input
                      value={editSettings.weight_high}
                      onChange={(e) =>
                        setEditSettings({
                          ...editSettings,
                          weight_high: e.target.value,
                        })
                      }
                      className="w-full p-4 pt-2 pb-2 rounded-xl border-2 border-slate-100 bg-slate-50 font-bold text-slate-700 outline-none focus:border-blue-500 focus:bg-white transition-all shadow-sm"
                    />
                  </div>
                </div>
              </section>

              {/* Section: Hardware Settings */}
              <section className="space-y-4">
                <h4 className="text-[10px] font-black text-blue-600 uppercase tracking-[0.2em] mb-4">
                  Hardware Config
                </h4>

                <div className="group">
                  <label className="block text-[10px] font-black text-slate-400 uppercase mb-2">
                    Reader Type
                  </label>
                  <select
                    value={editSettings.reader_type}
                    onChange={(e) =>
                      setEditSettings({
                        ...editSettings,
                        reader_type: e.target.value,
                      })
                    }
                    className="w-full p-4 pt-2 pb-2 rounded-xl border-2 border-slate-100 bg-slate-50 font-bold text-slate-700 outline-none focus:border-blue-500 focus:bg-white transition-all shadow-sm appearance-none cursor-pointer"
                  >
                    <option value="ASR550">ASR550</option>
                    <option value="FRD550">FRD550</option>
                    <option value="ESP650">ESP650</option>
                  </select>
                </div>

                <div className="grid grid-cols-2 gap-4">
                  <div className="group">
                    <label className="block text-[10px] font-black text-slate-400 uppercase mb-2">
                      Read Attempts
                    </label>
                    <input
                      value={editSettings.read_attempts}
                      onChange={(e) =>
                        setEditSettings({
                          ...editSettings,
                          read_attempts: e.target.value,
                        })
                      }
                      className="w-full p-4 pt-2 pb-2 rounded-xl border-2 border-slate-100 bg-slate-50 font-bold text-slate-700 outline-none focus:border-blue-500 focus:bg-white transition-all shadow-sm"
                    />
                  </div>
                  <div className="group">
                    <label className="block text-[10px] font-black text-slate-400 uppercase mb-2">
                      Weight Retry
                    </label>
                    <input
                      value={editSettings.weight_retry}
                      onChange={(e) =>
                        setEditSettings({
                          ...editSettings,
                          weight_retry: e.target.value,
                        })
                      }
                      className="w-full p-4 pt-2 pb-2 rounded-xl border-2 border-slate-100 bg-slate-50 font-bold text-slate-700 outline-none focus:border-blue-500 focus:bg-white transition-all shadow-sm"
                    />
                  </div>
                </div>
              </section>

              {/* Section: Connectivity */}
              <section className="space-y-4">
                <h4 className="text-[10px] font-black text-blue-600 uppercase tracking-[0.2em] mb-4">
                  Connection & Sync
                </h4>
                <div className="group">
                  <label className="block text-[10px] font-black text-slate-400 uppercase mb-2">
                    Broadcast Mode
                  </label>
                  <select
                    value={editSettings.broadcast_mode}
                    onChange={(e) =>
                      setEditSettings({
                        ...editSettings,
                        broadcast_mode: e.target.value,
                      })
                    }
                    className="w-full p-4 pt-2 pb-2 rounded-xl border-2 border-slate-100 bg-slate-50 font-bold text-slate-700 outline-none focus:border-blue-500 focus:bg-white transition-all appearance-none cursor-pointer shadow-sm"
                  >
                    <option value="Batch">Batch Mode</option>
                    <option value="Online">Real-Time Online</option>
                  </select>
                </div>

                <div className="grid grid-cols-2 gap-4 pt-2">
                  {/* <div className="flex items-center justify-between p-5 rounded-[1.5rem] bg-slate-50 border border-slate-100 transition-all hover:border-blue-100">
              <div className="flex flex-col">
                <span className="font-black text-slate-700 text-sm">Cellular</span>
              </div>
              <label className="relative inline-flex items-center cursor-pointer">
                <input 
                  type="checkbox" 
                  className="sr-only peer"
                  checked={editSettings.cellular}
                  onChange={() => setEditSettings({ ...editSettings, cellular: !editSettings.cellular })}
                />
                <div className="w-12 h-6 bg-slate-200 peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600"></div>
              </label>
            </div> */}

                  <div className="flex items-center justify-between p-5 rounded-[1.5rem] bg-slate-50 border border-slate-100 transition-all hover:border-blue-100">
                    <div className="flex flex-col">
                      <span className="font-black text-slate-700 text-sm">
                        Notification
                      </span>
                    </div>
                    <label className="relative inline-flex items-center cursor-pointer">
                      <input
                        type="checkbox"
                        className="sr-only peer"
                        checked={editSettings.notification}
                        onChange={() =>
                          setEditSettings({
                            ...editSettings,
                            notification: !editSettings.notification,
                          })
                        }
                      />
                      <div className="w-12 h-6 bg-slate-200 peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600"></div>
                    </label>
                  </div>
                </div>
              </section>
              <section className="space-y-3">
                <h4 className="text-[10px] font-black text-blue-600 uppercase tracking-[0.2em] mb-2">
                  Internet Connection
                </h4>

                {firmwareMap[editSite.mac.toLowerCase()] ? (
                  <div className="flex gap-3">
                    {/* WIFI */}
                    <span
                      className={`px-4 py-2 rounded-xl text-xs font-black ${
                        firmwareMap[editSite.mac.toLowerCase()]
                          .internet_mode === "WIFI"
                          ? "bg-emerald-100 text-emerald-700"
                          : "bg-slate-100 text-slate-400"
                      }`}
                    >
                      📶 WiFi:
                      {firmwareMap[editSite.mac.toLowerCase()].internet_mode ===
                      "WIFI"
                        ? "Connected"
                        : "Not Connected"}
                    </span>

                    {/* CELLULAR */}
                    <span
                      className={`px-4 py-2 rounded-xl text-xs font-black ${
                        firmwareMap[editSite.mac.toLowerCase()]
                          .internet_mode === "CELLULAR"
                          ? "bg-blue-100 text-blue-700"
                          : "bg-slate-100 text-slate-400"
                      }`}
                    >
                      📡 Cellular:
                      {firmwareMap[editSite.mac.toLowerCase()].internet_mode ===
                      "CELLULAR"
                        ? "Connected"
                        : "Not Connected"}
                    </span>
                  </div>
                ) : (
                  <div className="flex gap-3">
                    {/* WIFI */}
                    <span
                      className={`px-4 py-2 rounded-xl text-xs font-black ${"bg-slate-100 text-slate-400"}`}
                    >
                      📶 WiFi:Not Connected
                    </span>

                    {/* CELLULAR */}
                    <span
                      className={`px-4 py-2 rounded-xl text-xs font-black ${"bg-slate-100 text-slate-400"}`}
                    >
                      📡 Cellular:Not Connected
                    </span>
                  </div>
                )}
              </section>
            </div>

            {/* Footer Buttons */}
            <div className="p-10 pt-4 pb-4 bg-slate-50/80 backdrop-blur-md flex gap-4 justify-end border-t border-slate-100">
              <button
                onClick={() => setEditSite(null)}
                className="px-8 py-4 rounded-2xl text-slate-500 font-black hover:bg-white hover:text-slate-700 transition-all uppercase text-xs tracking-widest"
              >
                לְבַטֵל
              </button>

              <button
                onClick={saveSiteSettings}
                className="px-12 py-4 rounded-2xl bg-slate-900 text-white font-black hover:bg-blue-600 shadow-[0_10px_20px_-5px_rgba(15,23,42,0.3)] transition-all active:scale-95 uppercase text-xs tracking-widest flex items-center gap-2"
              >
                <span>💾</span> שמור שינויים
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
const TableRow = ({
  site,
  onView,
  onDelete,
  onDeleteSite,
  userRole,
  actionMenu,
  setActionMenu,
  onEdit,
}) => (
  <tr className="hover:bg-slate-50/50 transition-colors group relative">
    <td className="px-4 py-6 truncate">
      <div className="flex items-center gap-3">
        <div className="w-2 h-2 rounded-full bg-blue-500" />
        <span className="font-black text-sm text-slate-800 truncate">
          {site.name}
        </span>
      </div>
    </td>

    <td className="px-4 py-6 font-mono font-bold text-emerald-600">
      {site.calvesCount}
    </td>
    <td className="px-4 py-6">
      <span
        className={`px-4 py-1.5 rounded-full text-[10px] font-black uppercase tracking-wider ${
          site.calvesCount > 0
            ? "bg-emerald-100 text-emerald-700"
            : "bg-slate-100 text-slate-400"
        }`}
      >
        {site.calvesCount > 0 ? "Active" : "No Database"}
      </span>
    </td>

    {/* ACTIONS */}
    <td className="px-4 py-6 text-center relative ">
      <button
        onClick={(e) => {
          e.stopPropagation(); // prevent outside click
          setActionMenu(actionMenu === site.mac ? null : site.mac);
        }}
        className="p-2  text-slate-400 hover:text-slate-900 hover:bg-white hover:shadow-md rounded-xl transition-all"
      >
        <MoreVertical size={18} />
      </button>

      {actionMenu === site.mac && (
        <div
          onClick={(e) => e.stopPropagation()}
          className="absolute  right-5 top-14 z-50 bg-white border border-slate-100 shadow-xl rounded-2xl w-38 overflow-hidden"
        >
          <button
            onClick={() => {
              setActionMenu(null);
              onView(site);
            }}
            className="w-full flex gap-1 whitespace-nowrap px-4 py-3 text-sm font-bold hover:bg-slate-50 text-left"
          >
            <Eye size={20} />
            צפייה
          </button>

          <button
            onClick={() => {
              setActionMenu(null);
              onDelete(site.mac);
            }}
            className="w-full flex gap-1  whitespace-nowrap px-4 py-3 text-sm font-bold text-red-600 hover:bg-red-50 text-left"
          >
            <Trash2 size={20} /> מחק קובץ אצווה
          </button>
          {userRole === "admin" && (
            <button
              onClick={() => {
                setActionMenu(null);
                onDeleteSite(site.mac);
              }}
              className="w-full flex gap-1  whitespace-nowrap px-4 py-3 text-sm font-bold text-red-600 hover:bg-red-50 text-left"
            >
              <Trash2 size={20} /> מחק אתר
            </button>
          )}
          <button
            onClick={() => {
              setActionMenu(null);
              onEdit(site);
            }}
            className="w-full flex gap-1  px-4 whitespace-nowrap py-3 text-sm font-bold hover:bg-slate-50 text-left"
          >
            <Edit size={20} /> ערוך הגדרות
          </button>
        </div>
      )}
    </td>
  </tr>
);
const StatCard = ({ label, value, icon, color, bg, onClick, active }) => (
  <div
    onClick={onClick}
    className={`
  cursor-pointer bg-white p-8 rounded-[2.5rem] border
  transition-all group
  ${
    active
      ? "border-blue-500 shadow-xl scale-[1.03] ring-2 ring-blue-400 ring-offset-2"
      : "border-slate-100 hover:shadow-xl"
  }
`}
  >
    <div
      className={`w-12 h-12 ${bg} ${color} rounded-2xl flex items-center justify-center mb-6`}
    >
      {icon}
    </div>
    <p className="text-[11px] font-black text-slate-400 uppercase tracking-widest mb-1">
      {label}
    </p>
    <h4 className="text-3xl font-black text-slate-900 font-mono tracking-tighter">
      {value}
    </h4>
  </div>
);
export default DatabaseManagement;
